import React, { Component } from "react";
import { request as xhr, queryString } from "../utils/request";
import { AppContext } from "../utils/context";
import classnames from 'classnames';

import Alert from "../components/Alert";
import Button from "../components/Button";
import TextField from "../components/TextField";
import CheckboxField from "../components/CheckboxField";
import Validator from "validatorjs";
import ReCAPTCHA from "react-google-recaptcha";


const recaptchaRef = React.createRef();
let recaptchaKey;

class OrderDetails extends Component {
  constructor(props, context) {
    super(props);
    recaptchaKey = context.config.google_recaptcha_public_key;
    this.state = {
      xhr: {},
      orderDetails: null,
      validation: new Validator({}, {}),
      contact: {
        name: "",
        email: "",
        recaptcha: "",
        customer_preference: ""
      },
      xhr: {
        message: ""
      },
      disabled: context.config.option_require_recaptcha && context.config.option_recaptcha_type === 'v2', // if type is v2, submit is disabled until recaptcha complete
      recaptchaType: context.config.option_recaptcha_type
    };
  }

  componentDidMount = () => {    
    let contact = { ...this.state.contact };
    if (contact.name && contact.email) {
      this.setState({ disabled: false });
    } else {
      this.setState({ disabled: true });
    }
  };

  handleSubmit = () => {
    const { contact, recaptchaType } = this.state;
    const { config } = this.context;
    let rules = {
      name: "required",
      email: "required|email",
    };
    let validation = new Validator(contact, rules);

    if (validation.passes()) {
      this.setState({ validation: validation, disabled: true });
      if (config.option_require_recaptcha) {
        if (recaptchaType === 'v2') {
          this.submit();
        } else {
          recaptchaRef.current.executeAsync().then(value => {
            this.submit();
          });
        }
      } else {
        this.submit();
      } 
    } else {
      this.setState({ validation });
    }
  };

  submit = () => {
    const { contact, recaptchaType } = this.state;
    const { localLanguage, config } = this.context;

    //store recaptcha value in what is sent to server
    contact.recaptcha = config.option_require_recaptcha ? recaptchaRef.current.getValue() : '';
    contact.locale = localLanguage.setLocale.substring(0,2);

    const qs = queryString.parse(this.props.location.search);
    const orderId = qs.orderId ? qs.orderId : qs.orderid;
    const hash = qs.hash ? qs.hash : (qs.orderhash ? qs.orderhash : '');
    const threadId = qs.threadId ? qs.threadId : '';

    const params = {
      'hash': hash,
      'order_id': orderId,
      'thread_id': threadId,
      'email': contact.email,
      'name':  contact.name,
      'locale': contact.locale,
      'customer_preference[accept-sms]': contact.customer_preference ? 1 : 0,
      'recaptcha': contact.recaptcha
    };

    xhr.post(`api:/web/order/details`, params, 60000).then(response => {
      this.setState({'orderDetails' : response['data'], xhr: response });
    });
  };

  handleChange = e => {
    let { name, value, checked } = e.target;
    let contact = { ...this.state.contact };

    contact[name] = name == 'customer_preference' ? checked : value;
    this.setState({ contact });
  
    if (contact.name && contact.email) {
      this.setState({ disabled: false });
    } else {
      this.setState({ disabled: true });
    }
  };

  render() {
    const { contact, validation, xhr, disabled, recaptchaType, orderDetails } = this.state;
    const { errors } = validation.errors;
    const { localLanguage, settings } = this.context;
    const heroBoxClassnames = classnames('container', 'content', 'm-auto', { 'box-it': +settings.checkout_box_highlighting === 1 });

    let checkboxOptions = [{
      'text': localLanguage.general_order_receive_emails.replace('{title}', settings.web_email_label),
      'value': 'accept-sms',
      'checked': contact.customer_preference
    }];

    return (
      <div className=" mx-auto py-6 video-main video-bg" style={{ backgroundColor: settings.hero_background_color }}>
        <div className="video cover align-center align-middle">
          {settings.checkout_background_image && settings.checkout_background_image !== "" && (
            <img
              src={`${settings.checkout_background_image}`}
              alt=""
              className="opacity-75"
            />)
          }
        </div>
        <div className={heroBoxClassnames}>
          {!orderDetails && <div className="orderDetailsForm">
            <div className="content">
              {xhr.message !== "" && (
                <div className="flex flex-wrap mb-6">
                  <div className="w-full md:w-1/2">
                    <Alert
                      error={xhr.errors || xhr.exception}
                      success={xhr.success}
                      message={xhr.message}
                    />
                  </div>
                </div>
              )}
              <div className="flex flex-wrap mb-6">
                <TextField
                  container="w-full md:w-1/2"
                  id="name"
                  name="name"
                  value={contact.name}
                  label={localLanguage.general_first_name}
                  placeholder={localLanguage.general_first_name}
                  required
                  handleChange={this.handleChange}
                  hasError={errors["name"]}
                  displayError={localLanguage.general_field_is_required}
                  language={localLanguage.setLocale}
                />
              </div>
              <div className="flex flex-wrap mb-6">
                <TextField
                  container="w-full md:w-1/2"
                  id="email"
                  name="email"
                  value={contact.email}
                  label={localLanguage.general_email}
                  placeholder={localLanguage.general_email}
                  required
                  handleChange={this.handleChange}
                  hasError={errors["email"]}
                  displayError={localLanguage.general_field_is_required}
                  language={localLanguage.setLocale}
                />
              </div>
              <div className="flex flex-wrap mb-6">
                <CheckboxField
                  container="w-full px-3"
                  name="customer_preference"
                  options={checkboxOptions}
                  handleChange={this.handleChange}
                  label={false}
                  language={localLanguage.setLocale}
                />
              </div>

              {this.context.config.option_require_recaptcha && <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={recaptchaKey}
                onChange={recaptchaType === 'v2' ? this.onChange : null}
                size={recaptchaType === 'v2' ? 'small' : 'invisible'}
              />}

              {!disabled  && <div className="flex flex-wrap mb-6">
                <span
                  onClick={this.handleSubmit}
                  className="cursor-pointer w-auto no-underline bg-accent hover:bg-accent-dark text-primary font-bold text-xl py-4 px-6 rounded shadow-outline"
                >
                  {localLanguage.general_submit}
                </span>
              </div>}
            </div>
          </div>}

          {orderDetails != null && orderDetails.map((event) => (
          <div key={`ticket-info-${event.event_id}`} className="border rounded border-grey-light mb-3 p-3">
              {event['winner'][0]['winning_number'] && <div className="font-bold text-xl text-center m-2 border rounded border-grey-light bg-green-200 p-2">
                <p className="m-2">{localLanguage.general_order_winning_number.replace('{event_title}', event.event_title).replace('{winning_number}', event['winner'][0]['winning_number'])}</p>
                {event['winner'][0]['is_winner'] == 1 && 
                  <p className="mb-2">{localLanguage.general_order_is_winner.replace('{event_title}', event.event_title).replace('{ticket_number}', event['winner'][0]['winning_number'])}</p>
                }
                {event['winner'][0]['is_winner'] == 0 && 
                  <p className="mb-2">{localLanguage.general_order_not_winner.replace('{event_title}', event.event_title)}</p>
                }
              </div>}
              
              <div className="checkoutBox orderDetails">
                <div className="w-full md:w-2/3 p-5">
                  <div className="border rounded border-grey-light mb-3 p-3">
                    <p className="leading-normal mb-4">{localLanguage.general_event}: {event.event_title}</p>
                    {event.order_id && <p className="leading-normal mb-4">{localLanguage.general_order_id}: {event.order_id}</p>}
                    <p className="leading-normal mb-4">{localLanguage.general_order_status}: {localLanguage['general_order_' + event.status]}</p>
                    <p className="leading-normal mb-4">{localLanguage.general_order_payment_type}: {localLanguage['general_order_' + event.payment_type]}</p>
                    <p className="leading-normal mb-4">{localLanguage.general_order_payment_total}: {event.total_amount}</p>
                    {event.processing_fees && event.processing_fees !== '$0.00' && settings.display_processing_fee_tickets == '1' && (
                      <>
                        <p className="leading-normal mb-4">{localLanguage.processing_fees_label || 'Processing Fees'}: {event.processing_fees}</p>
                        <p className="leading-normal font-bold">{localLanguage.general_total || 'Total'}: {event.grand_total || event.total_amount}</p>
                      </>
                    )}
                    {event.reference && <p className="leading-normal mt-4">{localLanguage.general_reference_num}: {event.reference}</p>}
                    {event.envelope != null && event.envelope > 0 && <p className="leading-normal mt-4">{localLanguage.general_envelope_num}: {event.envelope}</p>}
                  </div>
                  <h2>{localLanguage.general_order_ticket_numbers}</h2>
                  <div className="border rounded border-grey-light p-3 mt-2">
                    {event.numbers && event.numbers.length > 0 && (
                      event.numbers.map((numberSet, setIndex) => (
                        <div key={`numberset-${setIndex}`} className="mb-4">
                          {event.number_model === 'single_number_multi_chance' ? (
                            <div className="flex flex-wrap">
                              {Object.entries(numberSet).map(([chances, number]) => (
                                <div key={`num-wrapper-${number}-${setIndex}`} className="w-full md:flex-1">
                                  <div className="text-lg text-center m-2 border rounded border-grey-light">
                                    <div className="px-6 py-4 whitespace-no-wrap">
                                      <div>{number}</div>
                                      <div className="text-sm text-gray-600">{localLanguage.general_chances_to_win} : {chances}</div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="flex flex-wrap">
                              {Array.isArray(numberSet) && numberSet.map(num => (
                                <div key={`num-wrapper-${num}-${setIndex}`} className="w-full md:flex-1">
                                  <div className="text-lg text-center m-2 border rounded border-grey-light">
                                    <div className="px-6 py-4 whitespace-no-wrap">{num}</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
          </div>
          ))}
        </div>
      </div>
    );
  }
}
OrderDetails.contextType = AppContext;
export default OrderDetails;
